import React, { useState, useEffect } from 'react'
import Helmet from 'react-helmet'

const ListingSearchSchema = (props) => {
  const [listingSearchSchema, setListingSearchSchema] = useState({})

  useEffect(() => {
    const listingSearchSchemaBuild = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Twisted Road Motorcycle Rental',
      brand: { '@type': 'Thing', name: 'Twisted Road' },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue:
          props.searchData?.results_meta?.average_rating === 0
            ? 1
            : props.searchData?.results_meta?.average_rating,
        ratingCount:
          props.searchData?.results_meta?.total_rating_count === 0
            ? 1
            : props.searchData?.results_meta?.total_rating_count,
      },
    }
    setListingSearchSchema(listingSearchSchemaBuild)
  }, [props.searchData])

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(listingSearchSchema)}
      </script>
    </Helmet>
  )
}

export default ListingSearchSchema

ListingSearchSchema.defaultProps = {
  searchData: {},
  url: 'https://www.twistedroad.com',
}
